import React, { useEffect, useRef, useState } from "react";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import { OnboardingCodeField } from "../parts/OnboardingCodeField";

const LoginCodeView = ({
  email,
  onBack,
  handleFieldChange,
  submitVerificationCode,
  resendVerificationCode,
  codeValue,
}) => {
  const codeRef = useRef();
  const [focusedCodeField, setFocusedCodeField] = useState(0);

  useEffect(() => {
    document.querySelector('input[name="code"]').focus();
  }, []);

  useEffect(() => {
    codeValue.length < 4 && setFocusedCodeField(codeValue.length);
  }, [codeValue]);

  const onCodeFieldClick = (focusIndex) => {
    const tempValue = codeValue.slice(0, focusIndex);
    codeRef.current.value = tempValue;

    handleFieldChange({ target: { name: "code", value: tempValue } });
    codeRef?.current?.focus();
  };

  return (
    <LoginWrapper
      mainClass="Onboarding athlete code"
      left={
        <form method="POST" data-noreset onSubmit={submitVerificationCode}>
          <BackArrowButton onBack={(_) => onBack(0)} />
          <div>
            <h1>Enter Verification Code</h1>
          </div>
          <p
            style={{
              color: "var(--primary)",
            }}
          >
            Check your email (
            <span style={{ color: "var(--information)" }}>{email}</span>) for
            your verification code
          </p>
          <div className="code-input-wrapper">
            <OnboardingCodeField
              value={codeValue[0]}
              onClick={() => onCodeFieldClick(0)}
              focused={focusedCodeField === 0}
            />
            <OnboardingCodeField
              value={codeValue[1]}
              onClick={() => onCodeFieldClick(1)}
              focused={focusedCodeField === 1}
            />
            <OnboardingCodeField
              value={codeValue[2]}
              onClick={() => onCodeFieldClick(2)}
              focused={focusedCodeField === 2}
            />
            <OnboardingCodeField
              value={codeValue[3]}
              onClick={() => onCodeFieldClick(3)}
              focused={focusedCodeField === 3}
            />
            <div className="code-box">
              <input
                ref={codeRef}
                type="text"
                name="code"
                id="code"
                maxLength="4"
                length="4"
                onChange={handleFieldChange}
                required
                sz="large"
                autoFocus
              />
            </div>
            <button
              data-button-type="secondary"
              onClick={resendVerificationCode}
              style={{ marginTop: 0, width: "auto" }}
            >
              Resend
            </button>
          </div>
          <button
            data-button-type="primary"
            sz="large"
            onClick={submitVerificationCode}
          >
            Continue
          </button>

          <p className="login-separator hr-lines">Having trouble logging in?</p>

          <a
            data-button-type="outline"
            role="button"
            sz="large"
            href="https://mystrengthbook.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Contact Us</span>
          </a>
        </form>
      }
    />
  );
};

export default LoginCodeView;
